import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";









var styles = {
  cardWrapper: function cardWrapper(_ref) {var isPortfolioInProposal = _ref.isPortfolioInProposal;return {
      borderRadius: '1rem',
      padding: '2.4rem 0',
      maxWidth: '52.8rem',
      height: 'fit-content', // stop component from vertical stretching
      boxSizing: 'border-box',
      backgroundColor: colors.neutral.white,
      outline: isPortfolioInProposal && "0.4rem solid ".concat(colors.green[600])
    };},
  cardHeader: {
    marginBottom: '1rem',
    padding: '0 3.2rem',
    flexWrap: 'wrap',
    gap: '1rem'
  },
  mobileCardHeader: {
    marginBottom: '1rem',
    padding: '0 2rem 2rem',
    flexDirection: 'column',
    gap: '1rem',
    justifyContent: 'center',
    // Tag list
    '& div:last-child': {
      gap: '1rem',
      justifyContent: 'flex-start',
      // Tag item
      '& p': {
        marginRight: 0
      }
    }
  },
  multiCardHeader: function multiCardHeader(_ref2) {var showMobileLayoutVersion = _ref2.showMobileLayoutVersion;return {
      marginBottom: '2.4rem',
      padding: showMobileLayoutVersion ? '0 1rem' : '0 2rem'
    };},
  tags: {
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  productNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 3.2rem',
    marginBottom: '1.5rem',
    minHeight: '5.2rem'
  },
  mobileProductNameWrapper: {
    padding: '0 2rem',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.5rem',
    minHeight: '5.2rem',
    '& > span': {
      display: 'none'
    },
    '& h2': {
      fontSize: '1.6rem',
      margin: {
        top: 0,
        right: 0,
        bottom: '1rem',
        left: 0
      }
    }
  },
  ratesList: function ratesList(_ref3) {var isDisabled = _ref3.isDisabled,showMobileLayoutVersion = _ref3.showMobileLayoutVersion;return {
      width: showMobileLayoutVersion ? 'auto' : '24rem',
      maxWidth: showMobileLayoutVersion && '24rem',
      '& li span:last-child': {
        color: isDisabled ? colors.neutral[700] : colors.green[600]
      }
    };},
  actionSection: function actionSection(_ref4) {var isPortfolioInProposal = _ref4.isPortfolioInProposal,showMobileLayoutVersion = _ref4.showMobileLayoutVersion;return {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '3rem',
      justifyContent: 'space-between',
      borderBottom: isPortfolioInProposal ? "0.1rem solid ".concat(
      colors.green[600]) : "0.1rem solid ".concat(
      colors.blue[600]),
      padding: showMobileLayoutVersion ? '0 2rem 2rem' : '0 3.2rem 1.2rem'
    };},
  planDetailsList: function planDetailsList(_ref5) {var
      isPortfolioInProposal = _ref5.isPortfolioInProposal,
      isMultiProductPortfolio = _ref5.isMultiProductPortfolio,
      showMobileLayoutVersion = _ref5.showMobileLayoutVersion;return (
      {
        padding: showMobileLayoutVersion ?
        '1rem' :
        isMultiProductPortfolio ?
        '1rem 2rem' :
        '1rem 3.2rem',
        // Attr item
        '& li': {
          padding: '0.8rem 0',
          marginBottom: 0,
          '&:not(:last-child)': {
            borderBottom: "0.1rem solid ".concat(colors.neutral[300])
          },
          '& span': {
            fontSize: showMobileLayoutVersion ? '1.4rem' : '1.2rem',
            lineHeight: '1.8rem',
            '&:first-child': {
              width: showMobileLayoutVersion ? '100%' : '32%',
              marginRight: '2rem',
              margin: showMobileLayoutVersion && 0,
              padding: 0,
              fontWeight: showMobileLayoutVersion ? 700 : 400
            }
          },
          flexDirection: showMobileLayoutVersion ? 'column' : 'row',
          // For mobile view
          justifyContent: showMobileLayoutVersion && 'flex-start',
          gap: showMobileLayoutVersion && '1rem'
        },
        backgroundColor: isPortfolioInProposal ? colors.green[100] : 'transparent',
        borderBottom: isMultiProductPortfolio ?
        'none' :
        isPortfolioInProposal ? "0.1rem solid ".concat(
        colors.green[600]) : "0.1rem solid ".concat(
        colors.blue[600])
      });},

  planDetailsButton: {
    textTransform: 'uppercase'
  },
  cardFooter: function cardFooter(_ref6) {var showMobileLayoutVersion = _ref6.showMobileLayoutVersion;return {
      padding: '2.4rem 3.2rem 0',
      display: 'flex',
      flexDirection: showMobileLayoutVersion ? 'column' : 'row',
      justifyContent: showMobileLayoutVersion ? 'center' : 'space-between',
      gap: '2rem',
      alignItems: 'center',
      '& label > span': {
        fontWeight: 400,
        textTransform: 'uppercase',
        fontSize: '1.4rem'
      },
      '& label': {
        cursor: 'pointer'
      }
    };},
  versionsMessage: function versionsMessage(_ref7) {var isMultiProductPortfolio = _ref7.isMultiProductPortfolio,showMobileLayoutVersion = _ref7.showMobileLayoutVersion;return {
      marginRight: isMultiProductPortfolio && !showMobileLayoutVersion ? '1rem' : 0,
      fontSize: showMobileLayoutVersion && '1.6rem',
      padding: 0
    };},
  configurePortfolioButton: function configurePortfolioButton(_ref8) {var showMobileLayoutVersion = _ref8.showMobileLayoutVersion;return {
      fontSize: showMobileLayoutVersion && '1.6rem',
      padding: 0
    };},
  disabledConfigureButton: {
    backgroundColor: 'transparent',
    color: colors.neutral[600],
    textTransform: 'none',
    cursor: 'not-allowed'
  },

  actionButtonWrapper: function actionButtonWrapper(_ref9) {var showMobileLayoutVersion = _ref9.showMobileLayoutVersion;return {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      flexDirection: 'column',
      gap: '0.5rem',
      // For mobile view
      width: showMobileLayoutVersion && '100%'
    };},
  cartButton: function cartButton(_ref10) {var showMobileLayoutVersion = _ref10.showMobileLayoutVersion;return {
      width: showMobileLayoutVersion ? '100%' : '15.8rem',
      height: showMobileLayoutVersion && '4.4rem',
      marginBottom: '0.5rem'
    };},
  // Styles for Portfolio with some products
  portfolioWrapper: function portfolioWrapper(_ref11) {var isPortfolioInProposal = _ref11.isPortfolioInProposal,showMobileLayoutVersion = _ref11.showMobileLayoutVersion;return {
      borderRadius: '1rem',
      // such values are used so that when choosing a plan, the elements don't change their places
      maxWidth: '110.8rem',
      boxSizing: 'border-box',
      backgroundColor: colors.neutral.white,
      outline: isPortfolioInProposal && "0.4rem solid ".concat(colors.green[600]),
      // Paddings
      paddingTop: isPortfolioInProposal ? '2.4rem' : '3.3rem',
      paddingBottom: 0,
      paddingLeft: showMobileLayoutVersion ? '2rem' : '3rem',
      paddingRight: showMobileLayoutVersion ? '2rem' : '3rem',
      gridColumn: '1/2' // stretch the card to 1 column on small screens
    };},
  '@media (min-width:1382px)': {
    // MAKE IT ONLY AS FUNCTION, DUE TO React-JSS media-queries bug!!!
    portfolioWrapper: function portfolioWrapper() {return {
        gridColumn: '1/3' // stretch the card into 2 columns on the browsing page
      };}
  },
  multiProductWrapper: function multiProductWrapper(_ref12) {var isPortfolioInProposal = _ref12.isPortfolioInProposal,isDisabled = _ref12.isDisabled,showMobileLayoutVersion = _ref12.showMobileLayoutVersion;return {
      marginBottom: '3rem',
      backgroundColor: isDisabled ? colors.neutral[100] : colors.neutral.white,
      opacity: isDisabled ? '0.6' : '1',
      paddingTop: '2.5rem',
      borderRadius: '1rem',
      maxWidth: '50rem',
      width: '50rem',
      // height: 'fit-content', // stop component from vertical stretching
      boxSizing: 'border-box',
      outline: isPortfolioInProposal ? "0.2rem solid ".concat(
      colors.green[600]) : "0.1rem solid ".concat(
      colors.neutral[300]),
      gap: showMobileLayoutVersion ? '2rem' : '3rem'
    };},
  portfolioCardHeader: function portfolioCardHeader(_ref13) {var isPortfolioInProposal = _ref13.isPortfolioInProposal,showMobileLayoutVersion = _ref13.showMobileLayoutVersion;return {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: showMobileLayoutVersion ? '2rem' : isPortfolioInProposal ? '0.9rem' : '2rem',
      // For mobile view
      gap: showMobileLayoutVersion && '2rem',
      '& svg': {
        display: showMobileLayoutVersion && 'none'
      }
    };},
  portfolioCardHeaderBottom: function portfolioCardHeaderBottom(_ref14) {var showMobileLayoutVersion = _ref14.showMobileLayoutVersion;return {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '3rem',
      marginBottom: '3rem',
      borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
      // For mobile view
      gap: showMobileLayoutVersion && '2rem',
      paddingTop: showMobileLayoutVersion && '2rem',
      borderTop: showMobileLayoutVersion && "0.1rem solid ".concat(colors.neutral[300])
    };},
  additionalButtonsWrapper: function additionalButtonsWrapper(_ref15) {var showMobileLayoutVersion = _ref15.showMobileLayoutVersion;return {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      // For mobile view
      gap: showMobileLayoutVersion ? '2rem' : '4rem',
      flexDirection: showMobileLayoutVersion ? 'column' : 'row',
      justifyContent: showMobileLayoutVersion && 'center',
      margin: showMobileLayoutVersion && '0 auto',
      // for compare checkbox
      '& label > span': {
        fontWeight: 400,
        textTransform: 'uppercase',
        fontSize: '1.4rem'
      },
      '& label': {
        cursor: 'pointer'
      }
    };},
  actionButtonRowView: {
    flexDirection: 'row-reverse',
    '& p': {
      margin: 0,
      marginRight: '2rem'
    }
  },
  portfolioNameWrapper: function portfolioNameWrapper(_ref16) {var showMobileLayoutVersion = _ref16.showMobileLayoutVersion;return {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      maxWidth: '90%',
      '& h2': {
        fontWeight: 700,
        fontSize: showMobileLayoutVersion ? '1.6rem' : '2.2rem',
        lineHeight: showMobileLayoutVersion ? '2.2rem' : '3.2rem',
        // For mobile view
        margin: showMobileLayoutVersion && 0,
        marginRight: showMobileLayoutVersion && 0,
        maxWidth: showMobileLayoutVersion && '100%'
      }
    };},
  multiProductsList: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  multiProductTopInfo: function multiProductTopInfo(_ref17) {var isPortfolioInProposal = _ref17.isPortfolioInProposal,showMobileLayoutVersion = _ref17.showMobileLayoutVersion;return {
      padding: showMobileLayoutVersion ? '0 1rem 1.2rem' : '0 2rem 1.2rem',
      borderBottom: isPortfolioInProposal ? "0.1rem solid ".concat(
      colors.green[600]) : "0.1rem solid ".concat(
      colors.blue[600])
    };},
  multiProductNameWrapper: function multiProductNameWrapper(_ref18) {var showMobileLayoutVersion = _ref18.showMobileLayoutVersion;return {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginBottom: '2rem',
      // For mobile view
      '& h2': {
        fontSize: showMobileLayoutVersion && '1.6rem',
        lineHeight: showMobileLayoutVersion && '2.2rem'
      }
    };}
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map